import {
  GET_USER_LIST_REQUEST,
  GET_USER_LIST_FAILURE,
  GET_USER_LIST_SUCCESS,
} from './global.constants';


export const getUserListAction = payload => ({ type: GET_USER_LIST_REQUEST, payload });
export const getUserListSuccess = payload => ({ type: GET_USER_LIST_SUCCESS, payload });
export const getUserListFailure = payload => ({ type: GET_USER_LIST_FAILURE, payload });
